import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
const { FiCheck, FiTrendingUp, FiClock, FiBrain, FiTarget, FiUsers, FiArrowRight, FiMail, FiPlay, FiStar, FiAward, FiHeart, FiMessageCircle, FiInstagram, FiSearch, FiX, FiArrowLeft } = FiIcons;

const HomePage = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [currentGallery, setCurrentGallery] = useState('');

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    setEmailError('');
    // Handle email submission
    console.log('Email submitted:', email);
    setEmail('');
    // Show success message
    alert('Thank you! We\'ll contact you within 24 hours.');
  };

  const trustedByLogos = [
    { src: 'https://i.ibb.co/N8NGbgw/pudhari-logo.png', alt: 'Pudhari logo' },
    { src: 'https://i.ibb.co/3nv0BWX/Screenshot-15-auto-x2-300x165.jpg', alt: 'WEAN logo' },
    { src: 'https://i.ibb.co/5xF01ffM/Screenshot-13-auto-x2-300x255.jpg', alt: 'Mrs India Fitness logo' },
    { src: 'https://i.ibb.co/Hcc88pz/kolhapur-sports-clup-428x443-1-290x300.png', alt: 'Kolhapur Sports Club logo' }
  ];

  const exerciseImages = [
    'https://i.ibb.co/prnVXWry/Results.png',
    'https://i.ibb.co/kgZcPMWH/Results-3.png',
    'https://i.ibb.co/DD4MGQst/Results-2.png',
    'https://i.ibb.co/x8GvC19j/Results-1.png',
    'https://i.ibb.co/JFF9VMMc/Results-4.png',
    'https://i.ibb.co/2YWbsHPj/Results-5.png',
    'https://i.ibb.co/tMjkWhLN/Results-7.png',
    'https://i.ibb.co/TBCH4h43/Results-8.png'
  ];

  const nutritionImages = [
    'https://i.ibb.co/6cDxNxjM/Food-Advice-7.png',
    'https://i.ibb.co/1HqGSRj/Food-Advice-6.png',
    'https://i.ibb.co/Q7KGps5r/Food-Advice-5.png',
    'https://i.ibb.co/nqPZvhNf/Food-Advice-4.png',
    'https://i.ibb.co/B5r2gX8Y/Food-Advice-3.png',
    'https://i.ibb.co/vvVDW4y9/Food-Advice-2.png',
    'https://i.ibb.co/rDWy29B/Food-Advice.png',
    'https://i.ibb.co/yF0C3GvC/Food-Advice-8.png'
  ];

  const teamImages = [
    'https://i.ibb.co/tTJxY13Z/Photo-Collage.png',
    'https://i.ibb.co/d0W0cD1k/IMG-6088-converted-1691465676-scaled.jpg',
    'https://i.ibb.co/1tVpyHSz/2-G0-A6667-scaled.jpg',
    'https://i.ibb.co/d44RvrLL/2-G0-A6446-scaled.jpg',
    'https://i.ibb.co/yB5Xp4KC/2-G0-A6498-scaled.jpg',
    'https://i.ibb.co/0VWMjxsp/2-G0-A6597-1-scaled.jpg',
    'https://i.ibb.co/v65sfrZR/2-G0-A6466-1-scaled.jpg',
    'https://i.ibb.co/Y7xC62jg/Whats-App-Image-2023-10-10-at-01-20-46-600x899.jpg'
  ];

  const charityImages = [
    'https://i.ibb.co/0jRsj1YT/Whats-App-Image-2024-01-20-at-9-52-57-PM-1-scaled.jpg',
    'https://i.ibb.co/VnCkFMY/Whats-App-Image-2024-01-20-at-9-52-57-PM-3-scaled.jpg',
    'https://i.ibb.co/SwxpZ0zM/Whats-App-Image-2024-01-20-at-9-53-04-PM-scaled.jpg'
  ];

  const testimonialImages = [
    'https://i.ibb.co/xKV9x8Fz/Snehal-Toshniwal-Testimonial-2.png',
    'https://i.ibb.co/vWGjR6H/Dhiraj-Gandhi-Testimonial.png',
    'https://i.ibb.co/ks7F4Kxk/Chirag-Kaswa-Testimonial.png',
    'https://i.ibb.co/HTcPxj1S/Jidnya-Shetiya-Testimonial.png'
  ];

  const openLightbox = (index, gallery) => {
    setLightboxIndex(index);
    setCurrentGallery(gallery);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextImage = () => {
    const images = currentGallery === 'exercise' ? exerciseImages :
      currentGallery === 'nutrition' ? nutritionImages :
        currentGallery === 'team' ? teamImages :
          currentGallery === 'charity' ? charityImages : testimonialImages;
    setLightboxIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    const images = currentGallery === 'exercise' ? exerciseImages :
      currentGallery === 'nutrition' ? nutritionImages :
        currentGallery === 'team' ? teamImages :
          currentGallery === 'charity' ? charityImages : testimonialImages;
    setLightboxIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="overflow-hidden bg-[#FFFDF8]">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#F9FFF5] to-[#EAF8EC] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div {...fadeInUp} className="space-y-8 text-center lg:text-left">
              <div className="inline-block">
                <span className="bg-[#2E7D32] text-white px-4 py-2 rounded-full text-sm font-medium">
                  Workout ✤ Diet ✤ Health ✤ Wellness
                </span>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0B1320] font-poppins leading-tight">
                India's Premier Nutrition Protocol
              </h1>
              <h2 className="text-2xl md:text-3xl font-semibold text-[#2E7D32] font-poppins">
                Unlock Your Body's Hidden Potential
              </h2>
              <p className="text-lg text-[#4A4A4A] leading-relaxed max-w-xl mx-auto lg:mx-0">
                What if the difference between where you are now and where you want to be isn't another diet or workout plan... but a completely different approach to nutrition?
              </p>
              <p className="text-sm text-[#9E9E9E]">
                Trusted by elite professionals across India
              </p>
            </motion.div>
            <motion.div {...fadeInUp} className="relative">
              <img
                src="https://i.ibb.co/d0W0cD1k/IMG-6088-converted-1691465676-scaled.jpg"
                alt="Healthy lifestyle scene at Sam's Nutri Hub."
                className="rounded-2xl shadow-2xl w-full"
              />
            </motion.div>
          </div>
          {/* Conversion Strip */}
          <motion.div {...fadeInUp} className="mt-12 max-w-4xl mx-auto">
            <form onSubmit={handleEmailSubmit} className="flex flex-col sm:flex-row gap-4 items-center">
              <div className="flex-1 w-full">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your Email"
                  className={`w-full px-6 py-4 rounded-lg border-2 ${emailError ? 'border-red-500' : 'border-gray-300'} focus:border-[#2E7D32] focus:outline-none transition-colors duration-200`}
                />
                {emailError && (
                  <p className="text-red-500 text-sm mt-1">{emailError}</p>
                )}
              </div>
              <button
                type="submit"
                className="bg-[#2E7D32] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#1B5E20] transition-all duration-200 transform hover:translate-y-[-1px] hover:shadow-lg whitespace-nowrap"
              >
                Reserve Your Spot
              </button>
              <Link
                to="/counselling"
                className="border border-[#2E7D32] text-[#2E7D32] bg-white px-6 py-4 rounded-lg font-semibold hover:bg-[#2E7D32] hover:text-white transition-all duration-200 transform hover:translate-y-[-1px] hover:shadow-lg text-center whitespace-nowrap"
              >
                Get Nutrition Counselling
              </Link>
            </form>
            <div className="mt-4 text-center">
              <p className="text-[#1B8D35] font-medium">
                Limited availability — Only 15 spots remaining this month
              </p>
            </div>
          </motion.div>
          {/* Testimonial Kicker */}
          <motion.div {...fadeInUp} className="mt-12 text-center max-w-4xl mx-auto">
            <blockquote className="text-xl md:text-2xl text-[#4A4A4A] italic font-merriweather leading-relaxed">
              "The transformation in my energy, focus, and physical presence was so dramatic, my colleagues thought I'd spent months at some exclusive wellness retreat. In reality, it was just 6 weeks of Sam's protocol."
            </blockquote>
            <cite className="text-[#4A4A4A] font-semibold not-italic mt-4 block">
              — Rajiv M., CEO
            </cite>
          </motion.div>
        </div>
      </section>

      {/* Trusted By Logos */}
      <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-8">
            <p className="text-[#9E9E9E] text-sm">Trusted by elite institutions</p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center"
          >
            {trustedByLogos.map((logo, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
              >
                <img src={logo.src} alt={logo.alt} className="max-h-12 w-auto object-contain" />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Paradox Metrics */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-6">
              The Paradox of Modern Elite
            </h2>
            <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
              You've mastered your profession — now it's time to master the fuel that drives your exceptional performance.
            </p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
          >
            {[
              { number: "27+", desc: "Average hours high-performers spend optimizing their career weekly" },
              { number: "3.5", desc: "Average hours spent on strategic nutrition and recovery" },
              { number: "9x", desc: "Increase in energy levels when nutrition is optimized for your body type" }
            ].map((stat, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="bg-white p-8 rounded-xl shadow-lg border-l-4 border-[#2E7D32]"
              >
                <div className="text-5xl font-bold text-[#2E7D32] mb-4 font-poppins">
                  {stat.number}
                </div>
                <p className="text-[#4A4A4A]">
                  {stat.desc}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Why Conventional Wellness Fails */}
      <section className="bg-[#FFFDF8] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-8"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins">
                Why Conventional Wellness Fails Exceptional
              </h2>
              <p className="text-lg text-[#4A4A4A] leading-relaxed">
                Standard nutrition advice isn't designed for those operating at the highest levels of performance and responsibility.
              </p>
              <div className="space-y-6">
                {[
                  { number: "1", title: "Time Constraints", desc: "Most protocols don't account for the demanding schedules of high-performers." },
                  { number: "2", title: "Social Obligations", desc: "Traditional diets fail to integrate with the social and business demands of elite professionals." },
                  { number: "3", title: "Mental Demands", desc: "Few nutrition plans optimize for cognitive performance and energy stability." }
                ].map((item) => (
                  <div key={item.number} className="flex items-start space-x-4">
                    <div className="bg-[#FAD74C] text-[#0B1320] w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0">
                      {item.number}
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-[#0B1320] mb-2">{item.title}</h3>
                      <p className="text-[#4A4A4A]">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center">
                <Link
                  to="/about"
                  className="inline-block border border-[#2E7D32] text-[#2E7D32] bg-white px-8 py-3 rounded-lg font-semibold hover:bg-[#2E7D32] hover:text-white transition-colors duration-200"
                >
                  See Real-World Solutions
                </Link>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <img
                src="https://i.ibb.co/1tVpyHSz/2-G0-A6667-scaled.jpg"
                alt="High-performer wellness challenges"
                className="rounded-2xl shadow-xl w-full"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Elite Wellness Protocol */}
      <section className="bg-[#205C25] py-20 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="bg-white text-[#205C25] px-4 py-2 rounded-full text-sm font-medium">
                Introducing
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold font-poppins mb-6">
              The Elite Wellness Protocol
            </h2>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              A pioneering approach to nutrition designed specifically for high-performers who demand excellence in every aspect of life.
            </p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
          >
            {[
              { title: "Physical Mastery", desc: "Optimize your body composition, energy levels, and recovery for peak physical performance." },
              { title: "Time-Efficient Protocols", desc: "Nutrition systems that integrate seamlessly with your demanding schedule and social obligations." },
              { title: "Cognitive Mastery", desc: "Fuel your mind for enhanced focus, decision-making capacity, and mental endurance." }
            ].map((feature, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="bg-white p-8 rounded-xl shadow-lg text-center"
              >
                <h3 className="text-xl font-semibold text-[#0B1320] mb-4 font-poppins">{feature.title}</h3>
                <p className="text-[#4A4A4A]">{feature.desc}</p>
              </motion.div>
            ))}
          </motion.div>
          <motion.div {...fadeInUp} className="text-center mt-12">
            <Link
              to="/body-analysis"
              className="inline-block border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-[#205C25] transition-colors duration-200"
            >
              Discover Your Protocol
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Science of Elevated Wellness */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-6">
              The Science of Elevated Wellness
            </h2>
            <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
              Unlike typical nutrition plans, our methodology is built on cutting-edge research specifically for high-performers.
            </p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
          >
            {[
              { number: "1", title: "Precision Assessment", desc: "We analyze your unique biochemistry, lifestyle demands, and performance goals to create a truly personalized protocol." },
              { number: "2", title: "Strategic Protocol Design", desc: "We create a comprehensive nutrition strategy that integrates with your existing lifestyle, not against it." },
              { number: "3", title: "Refined Implementation", desc: "Ongoing support and adjustments based on your progress and feedback ensure optimal results." }
            ].map((step, index) => (
              <motion.div key={index} variants={fadeInUp} className="text-center">
                <div className="bg-[#2E7D32] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-white">{step.number}</span>
                </div>
                <h3 className="text-xl font-semibold text-[#0B1320] mb-4 font-poppins">{step.title}</h3>
                <p className="text-[#4A4A4A]">{step.desc}</p>
              </motion.div>
            ))}
          </motion.div>
          <motion.div {...fadeInUp} className="text-center mt-12">
            <Link
              to="/body-analysis"
              className="inline-block bg-[#2E7D32] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#1B5E20] transition-all duration-200 transform hover:translate-y-[-1px] hover:shadow-lg"
            >
              Take Body Analysis Quiz
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Interactive Tools */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins">
              Interactive Tools for Your Journey
            </h2>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
          >
            {[
              { title: "Nutrition IQ Quiz", desc: "Test your knowledge, earn badges, and get personalized recommendations.", buttonText: "Take Quiz" },
              { title: "Meal Plan Generator", desc: "Create a customized meal plan based on your preferences and goals.", buttonText: "Generate Plan" },
              { title: "Workout Builder", desc: "Design a personalized workout routine tailored to your fitness level.", buttonText: "Build Workout" }
            ].map((tool, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="bg-[#F9FFF5] p-8 rounded-xl shadow-lg text-center"
              >
                <h3 className="text-xl font-semibold text-[#0B1320] mb-4 font-poppins">{tool.title}</h3>
                <p className="text-[#4A4A4A] mb-6">{tool.desc}</p>
                <Link
                  to="/interactive-tools"
                  className="inline-block border-2 border-[#2E7D32] text-[#2E7D32] bg-white px-6 py-3 rounded-lg font-semibold hover:bg-[#2E7D32] hover:text-white transition-colors duration-200"
                >
                  {tool.buttonText}
                </Link>
              </motion.div>
            ))}
          </motion.div>
          <motion.div {...fadeInUp} className="text-center mt-8">
            <p className="text-[#9E9E9E] text-sm">
              These tools appear during onboarding.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Exercise Results Carousel */}
      <section className="bg-[#FFFDF8] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="bg-[#2E7D32] text-white px-4 py-2 rounded-full text-sm font-medium">
                Workout ✤ Diet ✤ Health ✤ Wellness ✤
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-4">
              Passion for Helping People Live Healthier Through Optimal Exercise
            </h2>
            <h3 className="text-2xl font-semibold text-[#2E7D32] font-poppins mb-8">
              What's the Rundown on Our Exercise Inputs and Regimens?
            </h3>
          </motion.div>
          <motion.div {...fadeInUp} className="max-w-4xl mx-auto space-y-8 text-[#4A4A4A] leading-relaxed">
            <p>
              Picture the moment when a painter meets their canvas. We start with your blank slate, filling it with vibrant strokes of exercise inputs and regimes inspired by real-world success stories. The gallery of images we provide is not just an exhibit of exercises but a testament to genuine transformations. Seeing Is Believing!
            </p>
            <p>
              How do you know our exercise guidelines truly work? Just swipe through the snapshots in our collection. They showcase the meticulous details of each exercise and regimen, and even better, the triumphant results that our users have achieved. From Instructions to Triumph!
            </p>
            <p>
              It's one thing to provide guidelines, and another to see them put into action. Our image carousel is like a time machine. You begin by seeing the initial instructions and, as you swipe, you witness the journey of commitment, dedication, and, ultimately, the joy of accomplishment.
            </p>
            <p>
              Proof in the Pudding! There's an age-old saying, 'The proof of the pudding is in the eating'. Our gallery serves as that undeniable proof! From initial exercise recommendations to end results, it's a visual feast of transformation and motivation.
            </p>
          </motion.div>
          <motion.div {...fadeInUp} className="text-center mt-12 mb-12">
            <Link
              to="/body-analysis"
              className="inline-block bg-[#2E7D32] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#1B5E20] transition-all duration-200 transform hover:translate-y-[-1px] hover:shadow-lg"
            >
              Find out what your body needs
            </Link>
          </motion.div>
          {/* Image Carousel */}
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
          >
            {exerciseImages.map((image, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
                onClick={() => openLightbox(index, 'exercise')}
              >
                <img
                  src={image}
                  alt="Exercise inputs and real client results."
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <SafeIcon icon={FiSearch} className="h-8 w-8 text-white" />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Personalized Nutrition Gallery */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-6">
              Personalized Nutrition for Optimal Health and Wellness
            </h2>
          </motion.div>
          <motion.div {...fadeInUp} className="max-w-4xl mx-auto space-y-6 text-[#4A4A4A] leading-relaxed">
            <p>
              The Canvas of Culinary Craftsmanship! Dive into the vibrant realm of nutrition with Sam's Nutri Hub! Using locally sourced, wallet-friendly ingredients, we craft a nutrition plan as unique as you. Wave goodbye to cookie-cutter diet charts. Here, every bite is aligned to your specific biology and body type. Flip through our WhatsApp screenshot gallery to relive the magical moment of unveiling these personalized diets. Local Goodies for Global Transformations!
            </p>
            <p>
              Harnessing the potency of local ingredients, we've ensured that every meal plan is not just healthy, but also convenient and cost-effective. And the proof isn't just in the pudding; it's in the transformation images. As you swipe through, witness the incredible metamorphosis of our clients, from their 'before' to their 'after'. The Tale of Two Photos: A Journey of Nutritional Triumph!
            </p>
            <p>
              It's a visual diary of your journey with us. Start with the eager anticipation of 'before' and slowly move towards the jubilant triumph of 'after'. Each image captures more than just a physical change; it encapsulates the devotion, determination, and dance of local flavors and nutrients tailored just for you. From Screenshots to Success Shots!
            </p>
            <p>
              Scroll through our collection of WhatsApp snapshots that beautifully map out the culinary journey we designed for our clients. But don't stop there! Move ahead and bask in the glow of transformation images that stand as a testament to the power of tailored, local, and affordable nutrition. Nutrition Plans That Work for You.
            </p>
          </motion.div>
          {/* Image Gallery */}
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12"
          >
            {nutritionImages.map((image, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
                onClick={() => openLightbox(index, 'nutrition')}
              >
                <img
                  src={image}
                  alt="Personalized diet plan snapshots from WhatsApp."
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <SafeIcon icon={FiSearch} className="h-8 w-8 text-white" />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Elite Wellness Portfolios */}
      <section className="bg-[#FFFDF8] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-4">
              Elite Wellness Portfolios
            </h2>
            <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
              Strategic investments in your most valuable asset — your health and performance
            </p>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch"
          >
            {[
              {
                name: "Core Protocol",
                price: "₹75,000",
                subtitle: "One-time investment",
                features: "Comprehensive assessment · Personalized nutrition plan · 30-day meal guidance · Email support · Weekly check-ins",
                buttonText: "Learn More"
              },
              {
                name: "Elite Transformation",
                price: "₹1,25,000",
                subtitle: "One-time investment",
                popular: true,
                features: "Everything in Core Protocol · 90-day intensive support · Weekly 1:1 coaching calls · Personalized supplement strategy · Stress management protocol · Sleep optimization plan · Travel nutrition guidance",
                buttonText: "Select Plan"
              },
              {
                name: "Legacy",
                price: "₹2,50,000",
                subtitle: "One-time investment",
                features: "Everything in Elite Transformation · 12-month VIP support · Direct access to Sam · Quarterly in-person sessions · Family nutrition planning · Executive health monitoring · Lifetime program updates",
                buttonText: "Learn More"
              }
            ].map((plan) => (
              <motion.div
                key={plan.name}
                variants={fadeInUp}
                className={`bg-white p-8 rounded-xl shadow-lg relative flex flex-col ${plan.popular ? 'border-2 border-[#2E7D32] scale-105' : ''}`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-[#EAF8EC] text-[#205C25] px-4 py-2 rounded-full text-sm font-medium">
                      Most Popular
                    </span>
                  </div>
                )}
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-[#0B1320] mb-2 font-poppins">{plan.name}</h3>
                  <p className="text-4xl font-bold text-[#2E7D32] mb-2">{plan.price}</p>
                  <p className="text-[#9E9E9E] text-sm">{plan.subtitle}</p>
                </div>
                <p className="text-[#4A4A4A] mb-8 flex-grow text-sm">{plan.features}</p>
                <Link
                  to="/plans"
                  className="w-full bg-[#2E7D32] text-white py-3 px-6 rounded-lg font-semibold text-center hover:bg-[#1B5E20] transition-colors duration-200"
                >
                  {plan.buttonText}
                </Link>
              </motion.div>
            ))}
          </motion.div>
          <motion.div {...fadeInUp} className="text-center mt-12">
            <p className="text-[#4A4A4A] font-medium">
              All programs include our satisfaction guarantee. If you're not seeing results within 30 days, we'll refine your protocol or provide a full refund.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-4">
              The Transformation Chronicles
            </h2>
            <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
              Real results from high-performing professionals who demanded more
            </p>
          </motion.div>
          {/* Long-form stories would go here - placeholder for now */}
          <motion.div {...fadeInUp} className="text-center mb-12">
            <p className="text-[#4A4A4A] mb-8">
              Transformation stories coming soon with detailed case studies.
            </p>
          </motion.div>
          {/* Testimonial Images */}
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12"
          >
            {testimonialImages.map((image, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
                onClick={() => openLightbox(index, 'testimonial')}
              >
                <img
                  src={image}
                  alt="Client testimonial"
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <SafeIcon icon={FiSearch} className="h-8 w-8 text-white" />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Team Snapshot */}
      <section className="bg-[#FFFDF8] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins">
              Our Team
            </h2>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-4 gap-4"
          >
            {teamImages.map((image, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
                onClick={() => openLightbox(index, 'team')}
              >
                <img
                  src={image}
                  alt="Sam's Nutri Hub team."
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <SafeIcon icon={FiSearch} className="h-8 w-8 text-white" />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Community & Charity */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp} className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins">
              Giving Back — Free Events for Kids
            </h2>
          </motion.div>
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
          >
            {charityImages.map((image, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
                onClick={() => openLightbox(index, 'charity')}
              >
                <img
                  src={image}
                  alt="Sam's Nutri Hub free kids wellness event."
                  className="w-full h-64 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <SafeIcon icon={FiSearch} className="h-8 w-8 text-white" />
                </div>
              </motion.div>
            ))}
          </motion.div>
          <motion.div {...fadeInUp} className="text-center max-w-3xl mx-auto">
            <p className="text-[#4A4A4A]">
              We host free education and wellness events for children—because long-term health begins with knowledge, movement, and mindful nutrition.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Instagram Feed Section - Using your embed code */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-4">
              From the SNH Community
            </h2>
            <p className="text-[#4A4A4A] mb-2">
              Latest moments from our programs, client wins, and wellness events.
            </p>
            <p className="text-[#9E9E9E] text-sm">
              Instagram: <a href="https://www.instagram.com/samsnutrihub" target="_blank" rel="noopener noreferrer" className="text-[#2E7D32] hover:underline">https://www.instagram.com/samsnutrihub</a>
            </p>
          </div>
          {/* Instagram Embed - Using your provided code */}
          <div className="w-full">
            <iframe 
              src="https://widgets.sociablekit.com/instagram-feed/iframe/25614325" 
              frameborder="0" 
              width="100%" 
              height="1000"
              title="Instagram Feed"
              className="rounded-xl shadow-lg"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Final CTA Band */}
      <section className="bg-[#EAF8EC] py-20">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <motion.div {...fadeInUp}>
            <h3 className="text-3xl md:text-4xl font-bold text-[#0B1320] font-poppins mb-6">
              Your Legacy of Excellence Extends Beyond Business
            </h3>
            <p className="text-xl text-[#4A4A4A] mb-8 max-w-3xl mx-auto">
              The same precision and dedication that built your professional success can now transform your health and vitality.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
              <Link
                to="/body-analysis"
                className="bg-[#2E7D32] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#1B5E20] transition-all duration-200 transform hover:translate-y-[-1px] hover:shadow-lg"
              >
                Begin Your Transformation
              </Link>
              <Link
                to="/counselling"
                className="border border-[#2E7D32] text-[#2E7D32] bg-white px-8 py-4 rounded-lg font-semibold hover:bg-[#2E7D32] hover:text-white transition-all duration-200 transform hover:translate-y-[-1px] hover:shadow-lg"
              >
                Schedule a Consultation
              </Link>
            </div>
            <p className="text-[#9E9E9E] text-sm">
              Limited enrollment available for April 2025 — Only 15 spots remaining
            </p>
          </motion.div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white p-2 rounded-full hover:bg-white/10 transition-colors"
            aria-label="Close lightbox"
          >
            <SafeIcon icon={FiX} className="h-8 w-8" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-4 text-white p-3 rounded-full hover:bg-white/10 transition-colors"
            aria-label="Previous image"
          >
            <SafeIcon icon={FiArrowLeft} className="h-8 w-8" />
          </button>
          <div
            className="max-w-4xl max-h-[90vh] cursor-pointer"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={
                currentGallery === 'exercise' ? exerciseImages[lightboxIndex] :
                  currentGallery === 'nutrition' ? nutritionImages[lightboxIndex] :
                    currentGallery === 'team' ? teamImages[lightboxIndex] :
                      currentGallery === 'charity' ? charityImages[lightboxIndex] :
                        testimonialImages[lightboxIndex]
              }
              alt="Full size view"
              className="max-h-[80vh] object-contain"
            />
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-4 text-white p-3 rounded-full hover:bg-white/10 transition-colors"
            aria-label="Next image"
          >
            <SafeIcon icon={FiArrowRight} className="h-8 w-8" />
          </button>
        </div>
      )}
    </div>
  );
};

export default HomePage;